var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVehicleCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_989_10908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.416992C26.6504 0.416994 31.8998 0.852453 35.5361 4.47461C39.1788 8.10477 39.583 13.3569 39.583 20.0195C39.583 26.6748 39.1834 31.9222 35.5488 35.5537C31.9152 39.1854 26.6615 39.583 20 39.583C13.3386 39.583 8.08384 39.1854 4.4502 35.5537C0.815494 31.9229 0.416997 26.6749 0.416992 20.0195C0.416992 13.3653 0.8153 8.11876 4.44824 4.48926C8.08304 0.857174 13.3412 0.416992 20 0.416992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.416992C26.6504 0.416994 31.8998 0.852453 35.5361 4.47461C39.1788 8.10477 39.583 13.3569 39.583 20.0195C39.583 26.6748 39.1834 31.9222 35.5488 35.5537C31.9152 39.1854 26.6615 39.583 20 39.583C13.3386 39.583 8.08384 39.1854 4.4502 35.5537C0.815494 31.9229 0.416997 26.6749 0.416992 20.0195C0.416992 13.3653 0.8153 8.11876 4.44824 4.48926C8.08304 0.857174 13.3412 0.416992 20 0.416992Z",
    fill: "url(#paint0_linear_989_10908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.416992C26.6504 0.416994 31.8998 0.852453 35.5361 4.47461C39.1788 8.10477 39.583 13.3569 39.583 20.0195C39.583 26.6748 39.1834 31.9222 35.5488 35.5537C31.9152 39.1854 26.6615 39.583 20 39.583C13.3386 39.583 8.08384 39.1854 4.4502 35.5537C0.815494 31.9229 0.416997 26.6749 0.416992 20.0195C0.416992 13.3653 0.8153 8.11876 4.44824 4.48926C8.08304 0.857174 13.3412 0.416992 20 0.416992Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_989_10908)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 22.2225,
    r: 13.3333,
    fill: "#3C78F4",
    fillOpacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_989_10908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7598 20.332C11.5406 20.332 10.5508 21.3198 10.5508 22.54C10.5509 23.76 11.5405 24.749 12.7598 24.749C13.9804 24.749 14.9686 23.7599 14.9688 22.54C14.9688 21.32 13.9803 20.3321 12.7598 20.332ZM27.2656 20.332C26.0464 20.332 25.0566 21.3198 25.0566 22.54C25.0568 23.76 26.0464 24.749 27.2656 24.749C28.4848 24.749 29.4745 23.76 29.4746 22.54C29.4746 21.32 28.4862 20.332 27.2656 20.332ZM20 12.6328C18.7404 12.6328 17.4769 12.7364 16.3662 12.9463C15.2614 13.1551 14.283 13.473 13.6113 13.915V13.916C13.4475 14.024 13.2929 14.1964 13.1494 14.3975C13.003 14.6026 12.8552 14.8564 12.707 15.1436C12.4106 15.7182 12.1059 16.4478 11.8174 17.2441L11.6826 17.6162H28.3174L28.1826 17.2441C27.8934 16.4475 27.5886 15.7173 27.292 15.1426C27.1438 14.8555 26.995 14.6025 26.8486 14.3975C26.7051 14.1964 26.55 14.0228 26.3857 13.915C25.7145 13.4733 24.7369 13.155 23.6328 12.9463C22.5224 12.7364 21.2595 12.6328 20 12.6328ZM9.59375 25.4434L9.50586 25.3613L9.46875 25.3311C8.69939 24.6189 8.25266 23.6299 8.20312 22.5195L8.19824 22.2949C8.20256 21.3214 8.52745 20.3539 9.19141 19.5879L9.58984 19.1279H8.24414C8.06605 19.1277 7.91202 19.0027 7.87598 18.8281L7.50781 17.043V17.042L7.5 16.959C7.50159 16.876 7.53053 16.7948 7.58398 16.7295L7.58496 16.7285C7.65594 16.6411 7.76236 16.5899 7.87598 16.5898H10.5547L10.623 16.4111C10.9288 15.6103 11.2757 14.8242 11.6553 14.168C12.0385 13.5055 12.4388 13.0039 12.8389 12.7402C13.5832 12.2506 14.6558 11.8723 15.9121 11.6172C17.1642 11.3629 18.5812 11.2344 20.001 11.2344C21.4208 11.2344 22.8377 11.3629 24.0898 11.6172C25.3459 11.8723 26.4179 12.2507 27.1621 12.7402C27.562 13.0037 27.9622 13.5049 28.3457 14.167C28.7256 14.8229 29.073 15.6094 29.377 16.4111L29.4453 16.5898H32.124C32.2074 16.5898 32.2892 16.6183 32.3555 16.6699L32.417 16.7295C32.4873 16.8167 32.5145 16.931 32.4932 17.042L32.124 18.8262V18.8271C32.0889 19.0011 31.9359 19.127 31.7559 19.127H30.3467L30.7637 19.5908C31.4662 20.3722 31.8053 21.3745 31.8018 22.3809C31.7962 23.4959 31.3737 24.6054 30.4961 25.4092L30.4053 25.4922V28.0625C30.4053 28.45 30.0892 28.7664 29.7021 28.7666H27.4072C27.0191 28.7664 26.7041 28.4502 26.7041 28.0625V26.7812H13.2959V28.0625C13.2959 28.4504 12.9801 28.7666 12.5918 28.7666H10.2979C9.90962 28.7665 9.59375 28.4503 9.59375 28.0625V25.4434Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "url(#paint1_linear_989_10908)",
    strokeWidth: 0.555556
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_989_10908",
    x: -4.44461,
    y: -2.22195,
    width: 48.8887,
    height: 48.8887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.55556,
    result: "effect1_foregroundBlur_989_10908"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_989_10908",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145744,
    stopColor: "#3C78F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50BEE0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_989_10908",
    x1: 15.3086,
    y1: 11.5912,
    x2: 29.9102,
    y2: 22.0924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_989_10908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_989_10908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5562,
    height: 25.5556,
    fill: "white",
    transform: "translate(7.22168 7.22217)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicleCar);
export default __webpack_public_path__ + "static/media/icon_vehicle_car.e288defaf0f00938448dc43800975ca2.svg";
export { ForwardRef as ReactComponent };